import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Base from './Base';
import NumberFormat from 'cityads-v3/components/Format/NumberFormat';
import classNames from './Table.scss';

export default class Table extends Component {
  static propTypes = {
    columns: PropTypes.array,
    rows   : PropTypes.array,
  }

  render() {
    const { columns, rows } = this.props;

    return (
      <Base className={classNames.tableWidget}>
        <table className={classNames.table}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.name} className={classNames.th} data-column-name={column.name}>
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {columns.map((column) => (
                  <td key={column.name} className={classNames.td} data-column-name={column.name}>
                    {this.renderValue(row[column.name], column)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Base>
    );
  }

  renderValue(value, column) {
    const { type, precision } = column;

    switch (type) {
      case 'number':
        return <NumberFormat number={value} format={type} precision={precision} />;

      case 'string':
      default:
        return value;
    }
  }
}
